
























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import TeamAvatar from '@/modules/shared/components/TeamAvatar'

import { capitalSpacing, upperCase, date } from '@/utils'
import { RegionInfo } from '@/api/config'
@Component({
  filters: {
    upperCase,
    capitalSpacing,
    date
  },
  components: {
    TeamAvatar
  }
})
export default class TournamentCatalogItem extends Vue {
  @Prop({ required: true }) readonly tournamentId!: string
  @Prop({ required: true }) readonly banner!: string
  @Prop({ required: true }) readonly name!: string
  @Prop({ required: true }) readonly startTime!: number
  @Prop({ required: true }) readonly endTime!: number
  @Prop({ required: true }) readonly region!: RegionInfo[]
  @Prop({ required: true }) readonly game!: string
  @Prop({ required: true }) readonly state!: string
  @Prop({ required: true }) readonly prize!: string
  @Prop({ required: true }) readonly teamSize!: number

  /* Methods */
  async onTournamentCatalogItemClicked() {
    await this.$router.push({
      name: 'TournamentDetailsOverview',
      params: {
        tournamentId: this.tournamentId
      }
    })
  }
}
